'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _Modal = require('../../../Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _matrixJsSdk = require('matrix-js-sdk');

var _GroupStore = require('../../../stores/GroupStore');

var _GroupStore2 = _interopRequireDefault(_GroupStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupInviteTileContextMenu = function (_React$Component) {
    (0, _inherits3.default)(GroupInviteTileContextMenu, _React$Component);

    function GroupInviteTileContextMenu(props, context) {
        (0, _classCallCheck3.default)(this, GroupInviteTileContextMenu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (GroupInviteTileContextMenu.__proto__ || (0, _getPrototypeOf2.default)(GroupInviteTileContextMenu)).call(this, props, context));

        _this._onClickReject = _this._onClickReject.bind(_this);
        return _this;
    }

    (0, _createClass3.default)(GroupInviteTileContextMenu, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this._unmounted = false;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._unmounted = true;
        }
    }, {
        key: '_onClickReject',
        value: function _onClickReject() {
            var _this2 = this;

            var QuestionDialog = _index2.default.getComponent('dialogs.QuestionDialog');
            _Modal2.default.createTrackedDialog('Reject community invite', '', QuestionDialog, {
                title: (0, _languageHandler._t)('Reject invitation'),
                description: (0, _languageHandler._t)('Are you sure you want to reject the invitation?'),
                onFinished: async function onFinished(shouldLeave) {
                    if (!shouldLeave) return;

                    // FIXME: controller shouldn't be loading a view :(
                    var Loader = _index2.default.getComponent("elements.Spinner");
                    var modal = _Modal2.default.createDialog(Loader, null, 'mx_Dialog_spinner');

                    try {
                        await _GroupStore2.default.leaveGroup(_this2.props.group.groupId);
                    } catch (e) {
                        console.error("Error rejecting community invite: ", e);
                        var ErrorDialog = _index2.default.getComponent("dialogs.ErrorDialog");
                        _Modal2.default.createTrackedDialog('Error rejecting invite', '', ErrorDialog, {
                            title: (0, _languageHandler._t)("Error"),
                            description: (0, _languageHandler._t)("Unable to reject invite")
                        });
                    } finally {
                        modal.close();
                    }
                }
            });

            // Close the context menu
            if (this.props.onFinished) {
                this.props.onFinished();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    AccessibleButton,
                    { className: 'mx_RoomTileContextMenu_leave', onClick: this._onClickReject },
                    _react2.default.createElement('img', { className: 'mx_RoomTileContextMenu_tag_icon', src: require("../../../../res/img/icon_context_delete.svg"), width: '15', height: '15' }),
                    (0, _languageHandler._t)('Reject')
                )
            );
        }
    }]);
    return GroupInviteTileContextMenu;
}(_react2.default.Component); /*
                              Copyright 2018 Vector Creations Ltd
                              Copyright 2019 The Matrix.org Foundation C.I.C.
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */

GroupInviteTileContextMenu.propTypes = {
    group: _propTypes2.default.instanceOf(_matrixJsSdk.Group).isRequired,
    /* callback called when the menu is dismissed */
    onFinished: _propTypes2.default.func
};
exports.default = GroupInviteTileContextMenu;
module.exports = exports['default'];
//# sourceMappingURL=GroupInviteTileContextMenu.js.map